import Link from 'next/link';
import Icon from '@/components/ui/AppIcon';

interface InsightCardProps {
  insight: {
    id: string;
    title: string;
    excerpt: string;
    category: string;
    author: string;
    date: string;
    readTime: string;
    slug: string;
  };
}

const InsightCard = ({ insight }: InsightCardProps) => {
  return (
    <article className="group bg-card border border-border hover:shadow-elevated transition-all duration-base">
      <div className="p-lg">
        <div className="flex items-center justify-between mb-md">
          <span className="text-xs font-normal tracking-widest text-text-secondary uppercase">
            {insight.category}
          </span>
          <span className="text-xs text-text-secondary">
            {insight.readTime}
          </span>
        </div>
        
        <h3 className="text-xl font-light tracking-wide text-primary mb-sm group-hover:text-accent transition-colors duration-base">
          <Link href={`/insights/${insight.slug}`}>
            {insight.title}
          </Link>
        </h3>
        
        <p className="text-sm text-text-secondary mb-md leading-relaxed">
          {insight.excerpt}
        </p>
        
        <div className="flex items-center justify-between pt-md border-t border-border">
          <div className="flex items-center space-x-sm">
            <span className="text-xs text-text-secondary">
              {insight.author}
            </span>
            <span className="text-xs text-text-secondary">•</span>
            <span className="text-xs text-text-secondary">
              {insight.date}
            </span>
          </div>
          
          <Link 
            href={`/insights/${insight.slug}`}
            className="flex items-center space-x-xs text-xs text-primary hover:text-accent transition-colors duration-base"
          >
            <span>Read More</span>
            <Icon name="ArrowRightIcon" size={14} variant="outline" />
          </Link>
        </div>
      </div>
    </article>
  );
};

export default InsightCard;